import dJSON from 'dirty-json';

const moduleSelector = '.count-up';

/**
 * Module Init
 */
(() => {
  const modules = document.querySelectorAll(moduleSelector);
  if (!modules.length) return;

  modules.forEach((query) => {
    try {
      query.querySelector('script')?.remove(); // cleanup

      const { data } = dJSON.parse(query.data);

      data.forEach((item) => {
        query.querySelector('.count-up-grid').insertAdjacentHTML('beforeend', /* html */ `
          <div class="count-up-item">
            <h3 data-number="${item.number}"><span class="count-up"></span>${item.suffix ? `${item.suffix}` : ''}</h3>
            <p>${item.details}</p>
            <div class="progress-bar">
              <div class="progress-bar-inner" style="width: 0%;"></div>
            </div>
          </div>
        `);
      });
    } catch (error) {
      console.error(`Error: ${moduleSelector}`, error);
    }
  });
})();

/**
 * Count up USP h3
 */
(() => {
  function animateCountUp(element, targetNumber, duration = 3500) {
    const startNumber = 0;
    const startTime = performance.now();

    // Find the progress bar within the same count-up-item
    const countUpItem = element.closest('.count-up-item');
    const progressBar = countUpItem?.querySelector('.progress-bar-inner');

    function updateNumber(currentTime) {
      const elapsed = currentTime - startTime;
      const progress = Math.min(elapsed / duration, 1);

      const currentNumber = Math.floor(startNumber + (targetNumber - startNumber) * progress);

      element.textContent = currentNumber.toLocaleString();

      // Animate the progress bar simultaneously
      if (progressBar) {
        const progressWidth = progress * 100;
        progressBar.style.width = `${progressWidth}%`;
      }

      if (progress < 1) {
        requestAnimationFrame(updateNumber);
      } else {
        element.textContent = targetNumber.toLocaleString();
        // Ensure progress bar reaches 100% at the end
        if (progressBar) {
          progressBar.style.width = '100%';
        }
      }
    }

    requestAnimationFrame(updateNumber);
  }

  // Intersection Observer to trigger animation when element comes into view
  const observer = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        const h3 = entry.target.querySelector('h3');
        if (h3) {
          const rawNumber = h3.getAttribute('data-number');
          const number = parseInt(rawNumber.replace(/,/g, ''), 10);
          const countUp = h3.querySelector('.count-up');

          if (countUp && !Number.isNaN(number)) {
            animateCountUp(countUp, number);
            observer.unobserve(entry.target);
          }
        }
      }
    });
  });

  document.querySelectorAll('.count-up-item').forEach((item) => {
    observer.observe(item);
  });
})();
